// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"52de4fea","703":"c08db9a1"}[chunkId] + ".chunk.js";
};